import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { useAuth } from '../context/AuthContext';
import { OtpSignIn } from '../components/auth/OtpSignIn';

const AuthModal = ({ open, onClose }) => {
  const { clearPendingRedirect } = useAuth();
  const navigate = useNavigate();

  const handleSignedIn = (result) => {
    onClose();
    clearPendingRedirect();
    navigate(result.redirectUrl || '/app/home');
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="bg-white border-black/[0.08] rounded-3xl max-w-md p-0 overflow-hidden"
        data-testid="auth-modal"
      >
        <div className="pt-8 pb-6 px-8 text-center border-b border-black/[0.04]">
          <DialogTitle className="text-2xl font-heading font-semibold">Sign in to Flippex</DialogTitle>
          <DialogDescription className="text-foreground-muted mt-2">
            Enter your email and we will send you a code. New here? The same code creates your
            account.
          </DialogDescription>
        </div>

        <div className="px-8 pb-8 pt-6">
          <OtpSignIn onSignedIn={handleSignedIn} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;
